module.exports = __webpack_public_path__ + "img/partner-6.58855585.png";